module.exports = __webpack_public_path__ + "img/white-cloudBg.7cb5d8ee.jpg";